import * as React from "react";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styled } from "@mui/material";

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number, size?: number }
) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      {/* Background track */}
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={props?.size || 32}
        thickness={4}
        value={100}
      />
      {/* Actual progress */}
      <CircularProgress
        variant="determinate"
        sx={{
          position: "absolute",
          left: 0,
        }}
        size={props?.size || 32}
        thickness={4}
        {...props}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: "text.secondary", fontSize: props?.size ? "12px" : "8px", fontWeight: 700 }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

export default function CircularWithValueLabel(props: any) {
  const { progress, size } = props;

  return <CircularProgressWithLabel value={progress} size={size} />;
}